import { Route } from '@angular/router';
import { crmLandingRoute } from './crm-route.helpers';

const DASHBOARD_CRUMB = { id: 'dashboard', label: 'Panel de control' };

export const CRM_DASHBOARD_ROUTES: Route[] = [
  crmLandingRoute({
    path: 'dashboard/leads/leads',
    moduleId: 'dashboard',
    activeMenubarId: 'leads',
    title: 'Leads',
    breadcrumbs: [DASHBOARD_CRUMB, { id: 'leads', label: 'Leads' }],
    loadComponent: () =>
      import('../pages/dashboard/leads/leads/leads.component').then(
        (m) => m.DashboardLeadsComponent,
      ),
  }),
  crmLandingRoute({
    path: 'dashboard/advisors/advisors',
    moduleId: 'dashboard',
    activeMenubarId: 'advisors',
    title: 'Asesores y gerentes',
    breadcrumbs: [
      DASHBOARD_CRUMB,
      { id: 'advisors', label: 'Asesores y gerentes' },
    ],
    loadComponent: () =>
      import('../pages/dashboard/advisors/advisors/advisors.component').then(
        (m) => m.DashboardAdvisorsComponent,
      ),
  }),
  crmLandingRoute({
    path: 'dashboard/campaigns/campaigns',
    moduleId: 'dashboard',
    activeMenubarId: 'campaigns',
    title: 'Campañas',
    breadcrumbs: [DASHBOARD_CRUMB, { id: 'campaigns', label: 'Campañas' }],
    loadComponent: () =>
      import('../pages/dashboard/campaigns/campaigns/campaigns.component').then(
        (m) => m.DashboardCampaignsComponent,
      ),
  }),
  crmLandingRoute({
    path: 'dashboard/inventory/inventory',
    moduleId: 'dashboard',
    activeMenubarId: 'inventory',
    title: 'Inventario',
    breadcrumbs: [DASHBOARD_CRUMB, { id: 'inventory', label: 'Inventario' }],
    loadComponent: () =>
      import('../pages/dashboard/inventory/inventory/inventory.component').then(
        (m) => m.DashboardInventoryComponent,
      ),
  }),
  crmLandingRoute({
    path: 'dashboard/clients/clients',
    moduleId: 'dashboard',
    activeMenubarId: 'clients',
    title: 'Clientes',
    breadcrumbs: [DASHBOARD_CRUMB, { id: 'clients', label: 'Clientes' }],
    loadComponent: () =>
      import('../pages/dashboard/clients/clients/clients.component').then(
        (m) => m.DashboardClientsComponent,
      ),
  }),
];
